"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { UserScriptModel } from "UserActionHandler/UserScriptModel";
import { Fields, System } from "Constants/objects";
import { Messages } from "Messages";
/**
 * @module UserScriptField
 * @requires UserScriptModel
 * @exports UserScriptField
 */

/**
 * Class describes a field behaviour.
 */

export var UserScriptField =
/*#__PURE__*/
function () {
  /**
   * @param {UserScriptModel} model
   * @param {string} fieldName
   * @hideconstructor
   */
  function UserScriptField(model, fieldName) {
    _classCallCheck(this, UserScriptField);

    _defineProperty(this, "fieldName", void 0);

    _defineProperty(this, "model", void 0);

    this.model = model;
    this.fieldName = fieldName;
  }
  /**
   * @param {string} fieldName
   * @return {*}
   * @private
   */


  _createClass(UserScriptField, [{
    key: "_getFieldFilter",
    value: function _getFieldFilter(fieldName) {
      if (!fieldName || !this.model._fieldsViewSettings.hasOwnProperty(fieldName)) throw new Error("The form does not have field - \"".concat(fieldName, "\""));
      return this.model._fieldsViewSettings[fieldName]._filter;
    }
    /**
     * @param {string} fieldName
     * @param {array} flt
     * @return {*}
     * @private
     */

  }, {
    key: "_setFieldFilter",
    value: function _setFieldFilter(fieldName, flt) {
      if (!fieldName || !this.model._fieldsViewSettings.hasOwnProperty(fieldName)) throw new Error("Parameter \"flt\" has to be an array or null/undefined");

      if (!Array.isArray(flt) && flt == null) {
        throw new Error("The form does not have field - \"".concat(fieldName, "\""));
      }

      return this.model._fieldsViewSettings[fieldName]._filter = flt;
    }
    /**
     * @param fieldName
     * @param value
     * @private
     */

  }, {
    key: "_setFieldIsVisible",
    value: function _setFieldIsVisible(fieldName, value) {
      if (value !== 0 && value !== 1) throw new Error('Parameter "value" has to be 0 or 1');
      if (!fieldName || !this.model._fieldsViewSettings.hasOwnProperty(fieldName)) throw new Error("The form does not have field - \"".concat(fieldName, "\""));

      if (this.model._fieldsViewSettings[fieldName].IsVisible !== value) {
        this.model._fieldsViewSettings[fieldName][System._Changed] = true;
      }

      this.model._fieldsViewSettings[fieldName].IsVisible = value;
    }
    /**
     * @param fieldName
     * @return {number}
     * @private
     */

  }, {
    key: "_getFieldIsVisible",
    value: function _getFieldIsVisible(fieldName) {
      if (!fieldName || !this.model._fieldsViewSettings.hasOwnProperty(fieldName)) throw new Error("The form does not have field - \"".concat(fieldName, "\""));
      return this.model._fieldsViewSettings[fieldName].IsVisible;
    }
    /**
     * @param fieldName
     * @param value
     * @private
     */

  }, {
    key: "_setFieldIsReadOnly",
    value: function _setFieldIsReadOnly(fieldName, value) {
      if (value !== 0 && value !== 1) throw new Error('Parameter "value" has to be 0 or 1');
      if (!fieldName || !this.model._fieldsViewSettings.hasOwnProperty(fieldName)) throw new Error("The form does not have field - \"".concat(fieldName, "\""));

      if (this.model._fieldsViewSettings[fieldName].IsReadOnly !== value) {
        this.model._fieldsViewSettings[fieldName][System._Changed] = true;
      }

      this.model._fieldsViewSettings[fieldName].IsReadOnly = value;
    }
    /**
     * @param fieldName
     * @return {*|string}
     * @private
     */

  }, {
    key: "_getFieldIsReadOnly",
    value: function _getFieldIsReadOnly(fieldName) {
      if (!fieldName || !this.model._fieldsViewSettings.hasOwnProperty(fieldName)) throw new Error("The form does not have field - \"".concat(fieldName, "\""));
      return this.model._fieldsViewSettings[fieldName].IsReadOnly;
    }
    /**
     * @param name
     * @return {*}
     * @private
     */

  }, {
    key: "_getViewByName",
    value: function _getViewByName(name) {
      if (!name || !this.model._fieldsViewSettings.hasOwnProperty(name)) throw new Error("The form does not have the field - \"".concat(name, "\""));
      var view = this.model._fieldsViewSettings[name];
      return this._isDictionary(name) ? view[Fields.KeyFilterField] : view[Fields.ObjectFieldID_Name];
    }
    /**
     * @param fieldName
     * @param value
     * @private
     */

  }, {
    key: "_setFieldValue",
    value: function _setFieldValue(fieldName, value) {
      var name = this._getViewByName(fieldName);

      if (!name) throw new Error("The form does not have field - \"".concat(name, "\""));
      this.model._data[name] = value;
    }
    /**
     * @param fieldName
     * @return {*}
     * @private
     */

  }, {
    key: "_getFieldValue",
    value: function _getFieldValue(fieldName) {
      var name = this._getViewByName(fieldName);

      return this.model._data[name];
    }
    /**
     * @param fieldName
     * @param eventName
     * @param event
     * @private
     */

  }, {
    key: "_setFieldEvent",
    value: function _setFieldEvent(fieldName, eventName, event) {
      if (typeof event !== "function") throw new Error('Parameter "event" has to be function');
      if (!fieldName || !this.model._fieldsViewSettings.hasOwnProperty(fieldName)) throw new Error("The form does not have field - \"".concat(fieldName, "\""));
      this.model._fieldsViewSettings[fieldName][System._Changed] = true;
      this.model._fieldsViewSettings[fieldName][eventName] = event;
    }
    /**
     * @param name
     * @return {boolean}
     * @private
     */

  }, {
    key: "_isDictionary",
    value: function _isDictionary(name) {
      if (!name || !this.model._fieldsViewSettings.hasOwnProperty(name)) throw new Error("The form does not have the field - \"".concat(name, "\""));
      var view = this.model._fieldsViewSettings[name];
      return view[Fields.ObjectFieldID_LinkedObjectID] != null;
    }
  }, {
    key: "filter",
    value: function filter() {
      var flt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!this._isDictionary(this.fieldName)) return;
      if (flt == null || !flt.length) return this._getFieldFilter(this.fieldName);else return this._setFieldFilter(this.fieldName, flt);
    }
    /** If the argument is passed then the function sets the ReadOnly attribute else it returns the value of the attribute.
     *  Available values are 0 or 1.
     * @param {number} value
     * @return {number}
     * @example
     * SomeFieldChanged: function (fields) {
     *     var AmountFld = fields.getFieldByName(Amount);
     *
     *     if (!AmountFld.isReadOnly()) {
     *         AmountFld.isReadOnly(1);
     *     }
     *     return fields;
     * }
     */

  }, {
    key: "isReadOnly",
    value: function isReadOnly(value) {
      if (value != null) {
        this._setFieldIsReadOnly(this.fieldName, value);
      } else {
        return this._getFieldIsReadOnly(this.fieldName);
      }
    }
    /** If the argument is passed then the function sets the `IsVisible` attribute else it returns the value of the attribute.
     *  Available values are 0 or 1.
     * @param {number} value
     * @return {number}
     * @example
     * SomeFieldChanged: function (model) {
     *     var AmountFld = model.getFieldByName(Amount);
     *
     *     if (!AmountFld.isVisible()) {
     *         AmountFld.isVisible(1);
     *     }
     *     return model;
     * }
     */

  }, {
    key: "isVisible",
    value: function isVisible(value) {
      if (value != null) {
        this._setFieldIsVisible(this.fieldName, value);
      } else {
        return this._getFieldIsVisible(this.fieldName);
      }
    }
    /** If the argument is passed then the function sets the value else it returns the value of the field.
     * @param {*} [value]
     * @return {*}
     * @example
     * SomeFieldChanged: function (model) {
     *     var AmountFld = fields.getFieldByName(Amount);
     *
     *     AmountFld.value(AmountFld.value() + 150);
     *
     *     return model;
     * }
     */

  }, {
    key: "value",
    value: function value(_value) {
      if (typeof _value !== "undefined") {
        this._setFieldValue(this.fieldName, _value);
      } else {
        return this._getFieldValue(this.fieldName);
      }
    }
    /** Returns `true` if the field is a dictionary.
     * @return {boolean}
     * @example
     * SomeFieldChanged: function (model) {
     *     var AmountFld = model.getFieldByName(Amount);
     *
     *     if ( AmountFld.isDictionary()) {
     *         ...
     *     }
     *     return model;
     * }
     */

  }, {
    key: "isDictionary",
    value: function isDictionary() {
      return this._isDictionary(this.fieldName);
    }
    /**Returns display value of the dictionary. Uses only for dictionaries!
     * @return {String}
     * @example
     * ProductKindIDChanged: function (model) {
     *       console.log(model.getFieldByName(ProductKindID).displayValue);
     *
     *       return model;
     *   },
     */

  }, {
    key: "OnMasterSelectFilter",

    /**Calls when in a lookup pair a master was changed.
     * Note! This method must be called only on the `onBeforeEditRow` form event.
     * @deprecated use `onMasterSelectFilter` instead
     * @param {function} func Callback with the `UserScriptModel` parameter.
     * @see module:UserScriptField.UserScriptField#onMasterSelectFilter
     */
    value: function OnMasterSelectFilter(func) {
      console.warn(Messages.Warning.OnMasterSelectFilterDeprecated);
      this.onMasterSelectFilter(func);
    }
    /**Calls when in a lookup pair a master was changed.
     * Note! This method must be called only on the `onBeforeEditRow` form event.
     * @param {function} func Callback with the `UserScriptModel` parameter.
     * @see module:UserScriptModel.UserScriptModel
     * @see module:UserScriptModel.UserScriptModel#setCascadeSelectUpdating
     * @example
     * formInit(model) {
     *     let self = this;
     *     model.formEvents.onBeforeEditRow = function (event) {
     *         let firmFld = model.getFieldByName(Firm);
     *         let counteragentFld = model.getFieldByName(Counteragent);
     *
     *         firmFld.onMasterSelectFilter(self.updateInvoiceSelect);
     *         counteragentFld.onMasterSelectFilter(self.updateInvoiceSelect);
     *    };
     *    return model;
     * }
     */

  }, {
    key: "onMasterSelectFilter",
    value: function onMasterSelectFilter(func) {
      if (typeof func !== "function") throw new Error('Parameter `event` has to be function');

      var masterFunc = function masterFunc(view, data) {
        var newSettings = func(new UserScriptModel(_objectSpread({}, view), _objectSpread({}, data)));

        _.each(newSettings.getSourceView(), function (item) {
          var prev = _.find(view, function (v) {
            return v.ID === item.ID;
          });

          if (prev && JSON.stringify(prev['_filter']) !== JSON.stringify(item['_filter'])) {
            newSettings.getFieldByName(item.Name).value(null);
          }
        });

        return newSettings;
      };

      this._setFieldEvent(this.fieldName, 'onMasterSelectFilter', masterFunc);
    }
    /**Returns/sets `FieldType` of the editor.
     * @see module:UserScriptModel.UserScriptModel
     * @example
     * formInit(model) {
     *     model.formEvents.onEditorPreparing = (event) => {
     *
     *     const FIELD_TYPES = {
     *         NUMBER: 1,
     *         DATE: 2,
     *         BOOL: 3,
     *         TEXT: 0,
     *       };
     *
     *       let Cnt = event.getFieldByName('Cnt');
     *       if (Cnt.fieldType !== FIELD_TYPES.NUMBER) {
     *           Cnt.fieldType = FIELD_TYPES.NUMBER;
     *       }
     *
     *      return event;
     *    };
     *    return model;
     * }
     */

  }, {
    key: "displayValue",
    get: function get() {
      if (this.isDictionary() && this.model.initiatorIsFormEdit()) {
        //TODO переделать
        //у в формы редактирование могут быть только dxSelectBox
        var select = $("#form-edit-field-".concat(this.fieldName)).dxSelectBox('instance');
        return select.option('displayValue');
      }
    }
  }, {
    key: "fieldType",
    get: function get() {
      var view = this.model._fieldsViewSettings[this.fieldName];
      return view[Fields.ObjectFieldID_FieldType];
    },
    set: function set(value) {
      if (!Object.values(System.FIELD_TYPE).includes(value)) {
        throw new Error(Messages.Errors.UnsupportedFieldType);
      }

      var view = this.model._fieldsViewSettings[this.fieldName];

      if (view[Fields.ObjectFieldID_FieldType] !== value) {
        view[System._Changed] = true;
      }

      view[Fields.ObjectFieldID_FieldType] = value;
    }
    /**Returns/sets `LinkedObjectID.Name` of the editor.
     * @see module:UserScriptModel.UserScriptModel
     * @example
     * formInit(model) {
     *     model.formEvents.onEditorPreparing = (event) => {
     *
     *      let ProductID = event.getFieldByName('ProductID');
     *      if (ProductID.linkedObjectIDName !== 'App_Product') {
     *          ProductID.linkedObjectIDName = 'App_Product';
     *      }
     *
     *      return event;
     *     };
     *    return model;
     * }
     */

  }, {
    key: "linkedObjectIDName",
    get: function get() {
      var view = this.model._fieldsViewSettings[this.fieldName];
      return view[Fields.ObjectFieldID_LinkedObjectID_Name];
    },
    set: function set(objectName) {
      if (typeof objectName !== 'string' && objectName != null) throw new TypeError();
      var view = this.model._fieldsViewSettings[this.fieldName];

      if (view[Fields.ObjectFieldID_LinkedObjectID_Name] !== objectName) {
        view[System._Changed] = true;
        view[Fields.ObjectFieldID_LinkedObjectID] = null;
        view[Fields.ObjectFieldID_LinkedObjectID_Name] = objectName;
      }
    }
  }]);

  return UserScriptField;
}();